import { api } from "@/services/api.js";
import axios from "axios";
import Router from "@/router";
import VueCookies from "vue-cookies";
import { ehErroVersaoInvalida } from "@/utils/versao";

export default {
  async getUsuario(context) {
    try {
      VueCookies.set("erros", "false");
      //pega as informações do usuário passando o token (que estão nos cookies)
      const usuario = await api.get("/login");
      await context.commit("UPDATE_USUARIO", usuario.data);
      await context.commit("UPDATE_LOGIN", true);
    } catch (e) {
      VueCookies.set("erros", "true");
      //* Só limpa token/estado em erros de token/sessão (400). Em erros
      //* de rede/servidor (timeout, POOL CLOSED, 5xx) ou de validação/banco (401)
      //* preservamos o token para evitar que outras abas (que detectam token
      //* ausente via focus) sejam deslogadas em cascata, e para permitir que
      //* o chamador exiba um overlay de "tentar novamente".
      const status = e && e.response && e.response.status;
      if (status === 400 && !ehErroVersaoInvalida(e)) {
        context.commit("UPDATE_USUARIO", {
          id: "",
          nome: "",
          email: "",
          direitos: []
        });
        VueCookies.remove("token");
        context.commit("UPDATE_LOGIN", false);
      }
      //* Propaga o erro para o chamador tratar
      throw e;
    }
  },
  async logarUsuario(context, payload) {
    //* Busca o ip local do usuário
    var ip = { ip: "" };

    try {
      const response = await axios.get("https://ipinfo.io/ip");
      ip = { ip: response.data };
    } catch {}

    return api
      .loginAuth({
        username: payload.email,
        password: payload.senha,
        chave: "Su1t@SIM"
      })
      .then((response) => {
        //se deu tudo certo, seta o token
        return api
          .login({
            client_id: response.data.sigla + response.data.idSite,
            client_secret: "SuitaSIM",
            code: response.data.token,
            ip: ip.ip
          })
          .then((response) => {
            //se deu tudo certo, seta o token
            VueCookies.set("token", `${response.data.token}`, "12h", "/", "", true, "Strict");
          });
      });
  },
  deslogarUsuario(context) {
    context.commit("UPDATE_USUARIO", {
      id: "",
      nome: "",
      email: "",
      direitos: []
    });
    VueCookies.remove("token");
    VueCookies.remove("senhaPendente");
    context.commit("UPDATE_LOGIN", false);
    if (Router.currentRoute.path !== "/login") {
      Router.push("/login").catch(() => {});
    }
  }
};
